import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { trackPageLoad, identify } from '@nexus/fff-analytics';
import { useLocation } from 'react-router-dom';
import { toString } from 'lodash';

import { selectPageTrackingData } from 'selectors/trackingSelector';

const withPageTracking = (Component) => {
  const PageTrackingHOC = (props) => {
    const { trackingData } = props;
    const { user_id: userId } = trackingData;
    const optimizelyOptions = {
      Optimizely: {
        userId: toString(userId),
      },
    };

    const location = useLocation();

    useEffect(() => {
      // tracking segment page loaded event on all pages
      trackPageLoad({
        properties: trackingData,
        options: optimizelyOptions,
      });
      identify();
    }, [location.pathname]);

    return <Component {...props} />;
  };

  const mapStateToProps = (state) => ({
    trackingData: selectPageTrackingData(state),
    campaignId: state.campaignState.campaignId,
  });

  return connect(mapStateToProps)(PageTrackingHOC);
};

export default withPageTracking;
